<template>
  <div class="examHome mx-2">
    <a-spin :spinning="isLoading">
	    <div class="exam-content container">
            <b-row>
                <!-- <b-col class="d-flex flex-wrap area-category">
                    <div class="item-category"
                        v-for="(item, index) in categoryQuestion"
                        :key="item.value"
                        @click="chooseCategory(item.value, index)"
                        :class="{ act : activeIndex === index }"
                    >
                        {{ item.text }}
                    </div>
                </b-col> -->
                <SwiperSlide :setting="{
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    observeParents: true,
                    observer: true,
                    spaceBetween: 0,
                    loop: false,
                    pagination: false,
                    navigation: false,
                    scrollbar: true,
                    breakpoints: {}
                }" :content="'CategoryContent'" :data="categoryQuestion" :activeIndex="activeIndex" @change-category="chooseCategory" />


            </b-row>

		    <b-row class="py-4" align-h="between">
			    <b-col lg="3" sm="6">
				    <b-input-group>
					    <b-input-group-prepend is-text>
						    <b-icon icon="search"></b-icon>
					    </b-input-group-prepend>
					    <b-input
							    style="border-left: none"
							    @change="searchExams"
							    v-model="filterData.search"
							    :placeholder="$t('examStudent.label.placeholder_search')"
					    ></b-input>
				    </b-input-group>
			    </b-col>
			    <!-- <b-col lg="3" sm="6" class="p-0">
				    <b-row>
					    <b-col align-self="center" sm="4">
						    <label class="mx-0 my-2" style="white-space: nowrap"
						    >{{ $t("examStudent.label.category") }}:
						    </label>
					    </b-col>
					    <b-col align-self="center" sm="8">
						    <b-form-select
								    @change="fillterExam"
								    class="w-100 filter-dropdown"
								    :options="categoryQuestion"
								    v-model="filterData.category"
						    >
                  <template v-slot:first>
                    <b-form-select-option :value="null">
                      {{ $t("teacher_list.option_default") }}
                    </b-form-select-option>
                  </template>
						    </b-form-select>
					    </b-col>
				    </b-row>
			    </b-col> -->
		    </b-row>
		    <h5 class="page-name">{{ $t("examStudent.title") }}</h5>
		    <b-row style="overflow: auto; height: 70vh">
                <b-col
					    lg="3"
					    sm="6"
					    v-for="fData in examRequest"
					    v-bind:key="fData.id"
					    class="pb-4"
			    >
				    <!--					:img-src="fData.img"-->
				    <b-card
						    :img-src=" fData.image_s3?fData.image_s3 : 'https://mocvien.com/anh-tin-tuc/69.webp'"
						    img-top
						    tag="article"
						    class="mb-2 card-exam"
				    >
					    <div class=" card-title">
						    <span class=" pr-1" v-for="cate in fData.category">{{cate}}</span>
					    </div>
					    <b-card-text class="card-name">{{fData.name}}</b-card-text>

					    <b-row>
						    <b-col cols="7" class="card-author">{{ fData.created_by }}</b-col>
						    <b-col cols="5" class="text-right card-price__discount">
							    {{
								    numberWithCommas(
										    fData.price - (fData.price * fData.discount) / 100
								    )
							    }}
							    VND
						    </b-col>
					    </b-row>
					    <div class="card-price">
						    {{ numberWithCommas(fData.price) }} VND
					    </div>
					    <div class="row" v-if="fData.have_owner !== true && fData.discount !== 100">
						    <b-button class="col card-button card-button__buy" @click="buyNow(fData)">{{
								    $t("examStudent.button.buy")
							    }}
						    </b-button>
						    <b-button
								    class="col card-button card-button__add"
								    @click="addToCard(fData.id)"
										:disabled="fData.price === 0"
						    >
							    <img style="border: none"
							         src="https://img.icons8.com/windows/25/ffffff/shopping-cart-loaded--v1.png"
							    />
							    {{ $t("examStudent.button.add") }}
						    </b-button>
					    </div>
					    <div v-if="fData.have_owner !== true && fData.discount === 100" class="d-flex justify-content-center">
						    <b-button @click="handleDoExam(fData.id, fData.name)" class="card-button card-button__try">{{
								    $t("examStudent.button.try")
							    }}</b-button>
					    </div>
					    <div v-if="fData.have_owner === true" class="d-flex justify-content-center">
						    <b-button class="card-button card-button__own" @click="handleMyExam">{{
								    $t("examStudent.label.owner")
							    }}</b-button>
					    </div>
				    </b-card>
			    </b-col>
		    </b-row>
		    <div class="row py-3">
                <div class="col-12 col-md-8 d-flex align-items-center">
                    <div class="col-6 p-0 d-flex align-items-center">
                        <b-input
                            class="col-4 col-md-3 mr-1 mw-50"
                            type="number"
                            placeholder=""
                            @change="fillterExam"
                            v-model="filterData.selected.paginate"
                        >
                        </b-input>
                        bản ghi/Trang
                    </div>
                    <div class="col-6 p-0 d-flex align-items-center justify-content-end justify-content-lg-center">
                        Đến trang
                        <b-input
                            @change="fillterExam"
                            class="col-4 col-md-3 ml-1 mw-50"
                            type="number"
                            placeholder=""
                            v-model="filterData.page"
                        >
                        </b-input>

                    </div>
                </div>

                <div class="col-12 col-md-4 p-0">
                    <b-pagination
                        class="justify-content-end mt-2 pr-3"
                        :key="`${pagination.current_page}_${pagination.total}_${pagination.per_page}`"
                        @change="change"
                        :value="pagination.current_page"
                        :total-rows="pagination.total"
                        :per-page="pagination.per_page"
                        aria-controls="my-table"
                    ></b-pagination>
                </div>

            </div>
	    </div>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {notification} from "ant-design-vue";
import router         from "@/router";
import Cookies from "js-cookie";
import moment from "moment";
import SwiperSlide from "../../components/slide/SwiperSlide.vue";

export default {
  components: {SwiperSlide},
  data() {
    return {
			isLoading: false,
      categoryQuestion: {},
      filterData: {
        search: "",
        perPage: 8,
        page: 1,
        category_id: "",
        category: null,
        selected: {
          paginate: 8,
        },
      },
      activeIndex: 0
    };
  },
  async created() {
    window.history.replaceState(null, null, window.location.pathname);
    Cookies.remove("idExam");
    Cookies.remove("typeExam");
    Cookies.remove("idResultExam");
    localStorage.removeItem("exam-selected")
    await this.fillterExam();
    await this.getCategory();
    this.categoryQuestion = [];
    this.categoryQuestion = [
        { value: null, text: this.$t('teacher_list.option_default') },
        ...Object.values(this.listCategories).map(c => ({
            value: c.id,
            text: c.category
        }))
    ];
//     this.categoryQuestion.push({value : null, text: this.$t("teacher_list.option_default")});
// console.log(this.listCategories);
//     for (let i = 0; i < this.listCategories.length; i++) {
//       this.categoryQuestion.push({
//         value: this.listCategories[i].id,
//         text: this.listCategories[i].category,
//       });
//     }
  },
  computed: {
    ...mapGetters({
      examRequest: "student/getExamResponse",
      listCategories: "category/categoryb2c",
	    pagination: "student/pagination",
      user: "auth/user"
    }),
  },
  mounted() {},
  methods: {
	  moment,
    async handleDoExam(id, name) {
			await router.push(`/student/exam/try-exam?${id}&${name.replace(/ /g, "-")}`)
		},
	  handleMyExam(){
		  router.push("/student/exam/my-exam")
	  },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async fillterExam() {
      this.isLoading=true;
      await this.$store.dispatch("student/getListExam", this.filterData);
      this.isLoading=false;
    },
    searchExams(){
        this.filterData.page = 1;
        this.fillterExam();
    },
    async getCategory() {
      await this.$store.dispatch("category/getCategoryB2C");
      this.listCategory = this.listCategories;
    },
	  change: function (page) {
		  this.filterData.page = page;
		  this.fillterExam();
	  },
    openNotification: function (type, message, description) {
      notification[type]({
        message: message,
        description: description,
        duration: 3,
      });
    },
    async addToCard(id) {
      this.isLoading=true;
      const params = {
        user_id: this.user.id,
        id: id
      };
      await this.$store.dispatch("exam/addToCard", params);
      const apiRes = this.$store.state.exam.examInCart.status ? this.$store.state.exam.examInCart.status : this.$store.state.exam.examInCart;
      if (apiRes !== 200) {
        apiRes === 402
            ? this.openNotification("error", this.$t('examStudent.toast.error'),  this.$t('examStudent.toast.cantAdd_noti'))
            : this.openNotification("error", this.$t('examStudent.toast.error'), this.$t('examStudent.toast.error_noti'));
      } else {
        this.openNotification("success", this.$t('examStudent.toast.successfully'), this.$t('examStudent.toast.successfully_noti'));
      }
      await this.$store.dispatch("exam/getExamInCart", this.user.id);
      this.isLoading=false;
    },
    async buyNow(exam) {
      if (!(exam.price - (exam.price * exam.discount) / 100)) {
				const params = {
					exam: JSON.stringify([exam.id]),
				}
				await this.$store.dispatch("exam/getTransferExam", params);
				this.$success({
					title: h => <div style="fontWeight: bold;color:green;">{this.$t("payment.message.transfer_confirmation")} </div>,
					content: h => <div style="color:green;">{ this.$t("buyExam.label.please_wait_admin_confirm") }</div>,
					cancelButtonProps: {
						style: {display: "none"}
					},
					keyboard: false,
					// onOk() {
					// 	router.push("/student/exam/my-exam");
					// }
				});
				return
      }
      await localStorage.setItem("exam-selected", JSON.stringify([exam]));
      router.push("/student/exam/buy-exam");
    },
    chooseCategory(value, index){
        this.filterData.page = 1;
        this.filterData.category = value;
        this.activeIndex = index;
        this.fillterExam();
    },

  },
};
</script>

<style>
.examHome{
	height: 100vh;
}
.page-name {
	font-weight: 700;
	padding-left: 15px;
	font-size: 15px;
	line-height: 150%;
	color: #0e2b5e;
}
.row {
  margin: 0 !important;
}

.input-group-text {
  background-color: white;
}

.filter-dropdown {
  width: 70%;
  float: right;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  border: none;
  padding: 6px;
}

.exam-content {
  margin-top: 15px;
  padding: 15px;
  border-radius: 15px;
  background-color: #fff;
}

.exam-content .row {
  margin-bottom: 20px;
}

.card-exam {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: none;
}

.card-exam img {
  border-radius: 10px 10px 0px 0px;
	border-top: 1px solid #e8e8e8;
	border-bottom: 1px solid #e8e8e8;
}

.card-title {
  font-weight: 700;
  font-size: 16px !important;
  line-height: 19px;
  color: #ffbf00;
  margin-bottom: 7px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.card-body {
  padding: 7px 12px 13px 12px;
}

.card-price__discount,
.card-text,
.card-author,
.card-price {
  font-size: 12px;
  line-height: 150%;
}

.card-author {
  color: #0770ab;
  padding: 0px;
}
.card-name {
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 20px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.card-price__discount {
  padding: 0px;
  font-weight: 700;
  color: #f61717;
}

.card-price {
  text-align: right;
  text-decoration: line-through;
  padding-bottom: 5px;
}

.card-button {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  border: none;
  padding: 6px 0px;
  text-align: center;
}

@media (max-width: 992px) {
  .card-button {
    font-size: 12px;
  }
	.examHome{
		margin-bottom: 10px;
		height: unset;
	}
}

.card-button__buy {
  background-color: #35b560;
  margin-right: 11px;
}

.card-button__try {
  background-color: #35b560;
  padding: 9px 30px;
}

.card-button__try:hover {
  background-color: #2a924e !important;
  color: white !important;
}
.card-button__own {
	background-color: #3182CE;
	padding: 9px 30px;
	width: 100%;
}

.card-button__own:hover {
	background-color: #3182CE !important;
	color: white !important;
	cursor: default;
}
.card-button__own:focus{
	background-color: #3182CE !important;
	color: white !important;
}
.card-button__add {
  background-color: #ffbf00;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.card-button__buy:hover {
  background-color: #2a924e !important;
  color: white !important;
}

.card-button__add:hover {
  background-color: #edb300 !important;
  color: white !important;
}

.card-button__add:hover:disabled {
  background-color: #6c757d !important;
  color: white !important;
}

.card-img-top {
	height: 175px;
  object-fit: cover;
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1400px;
  }
}

.item-category{
    background: #e5eaff;
    color: #485cc7;

    border-radius: 10px;
    margin: 0 10px 10px 0px;
    font-size: 16px;
    padding: 8px 10px;
    cursor: pointer;
}
.item-category.act{
    background: #6674bb;
    color: #fff;
}
.card-name{
    white-space: pre-wrap;
}
</style>
